import React, { Fragment } from 'react'
import { PaginationButtonsProps } from './PaginationButtons.types'
import styles from './PaginationButtons.module.scss'
import cl from 'classnames'
import { Text1 } from '../Text1'
import { IconArrowLeft, IconArrowRight } from 'assets'
import { Button } from '../Button'

const PaginationButtonsComponent = (props: PaginationButtonsProps) => {
  const {
    alwaysShow,
    totalPages,
    selectedPageNumber,
    totalElements,
    elementsPerPage,
    onPageSelect,
    className,
    style
  } = props

  if (totalPages < 2 && !alwaysShow) return null

  const isSelectedPageFirst = selectedPageNumber === 0
  const isSelectedPageLast = selectedPageNumber === totalPages - 1

  const skippedItemsNumber = elementsPerPage * selectedPageNumber

  const shownElementMin = skippedItemsNumber + 1
  const shownElementMax = Math.min(skippedItemsNumber + elementsPerPage, totalElements)

  const selectPage = (pageNum: number) => {
    if (pageNum === selectedPageNumber) return
    onPageSelect && onPageSelect(pageNum)
  }

  return (
    <div className={cl(styles.container, className)} style={style}>
      <Text1 className={styles.infoText}>
        Showing {shownElementMin} to {shownElementMax} of {totalElements} results
      </Text1>

      <div className={styles.buttonsContainer}>

        <Button
          preset='icon'
          className={cl(styles.pageButton)}
          disabled={isSelectedPageFirst}
          onClick={() => selectPage(selectedPageNumber - 1)}
        >
          <IconArrowLeft />
        </Button>

        {totalPages <= 5
          ? (
            Array(totalPages).fill('').map((_, index) => {
              return (
                <Button
                  key={index}
                  preset='icon'
                  className={cl(styles.pageButton, {
                    [styles.selected]: index === selectedPageNumber
                  })}
                  onClick={() => selectPage(index)}
                >
                  {index + 1}
                </Button>
              )
            })
          )
          : (
            <Fragment>
              <Button
                preset='icon'
                className={cl(styles.pageButton, {
                  [styles.selected]: selectedPageNumber === 0
                })}
                onClick={() => selectPage(0)}
              >
                1
              </Button>

              {selectedPageNumber <= 2 && (
                <Fragment>
                  <Button
                    preset='icon'
                    className={cl(styles.pageButton, {
                      [styles.selected]: selectedPageNumber === 1
                    })}
                    onClick={() => selectPage(1)}

                  >
                    2
                  </Button>
                  <Button
                    preset='icon'
                    className={cl(styles.pageButton, {
                      [styles.selected]: selectedPageNumber === 2
                    })}
                    onClick={() => selectPage(2)}
                  >
                    3
                  </Button>
                </Fragment>
              )}

              <div className={styles.pageButton}>...</div>

              {selectedPageNumber > 2 && selectedPageNumber < totalPages - 3 && (
                <Fragment>
                  <Button
                    preset='icon'
                    className={cl(styles.pageButton, styles.selected)}
                  >
                    {selectedPageNumber + 1}
                  </Button>
                  <div className={styles.pageButton}>...</div>
                </Fragment>
              )}

              {selectedPageNumber >= totalPages - 3 && (
                <Fragment>
                  <Button
                    preset='icon'
                    className={cl(styles.pageButton, {
                      [styles.selected]: selectedPageNumber === totalPages - 3
                    })}
                    onClick={() => selectPage(totalPages - 3)}
                  >
                    {totalPages - 2}
                  </Button>
                  <Button
                    preset='icon'
                    className={cl(styles.pageButton, {
                      [styles.selected]: selectedPageNumber === totalPages - 2
                    })}
                    onClick={() => selectPage(totalPages - 2)}
                  >
                    {totalPages - 1}
                  </Button>
                </Fragment>
              )}

              <Button
                preset='icon'
                className={cl(styles.pageButton, {
                  [styles.selected]: selectedPageNumber === totalPages - 1
                })}
                onClick={() => selectPage(totalPages - 1)}
              >
                {totalPages}
              </Button>

            </Fragment>
          )}

        <Button
          preset='icon'
          className={cl(styles.pageButton)}
          disabled={isSelectedPageLast}
          onClick={() => selectPage(selectedPageNumber + 1)}
        >
          <IconArrowRight />
        </Button>

      </div>

    </div>
  )
}

const PaginationButtons = PaginationButtonsComponent
export { PaginationButtons }
